module.exports = __webpack_public_path__ + "img/no-data.d0fcc86a.png";